export const actMatchList = {
  0: '优惠券',
  1: '折',
  2: '满减',
  3: '积分',
  4: '特价',
  5: '秒杀',
  6: '拼团',
  22: '等级'
}

export function handlerActGoodsPrice(data) {
  return data.filter((item) => {
    if (item.actInfos && item.actInfos.length) {
      item.actInfos.forEach((act) => {
        switch (act.actType) {
          case 5:
            handlerActType5(act, item)
            break
          case 6:
            handlerActType6(act, item)
            break
          case 4:
            handlerActType4(act, item)
            break
          case 22:
            handlerActType5(act, item)
            break
        }
      })
    }
    return item.onSale
  })

  function handlerActType5(act, item) {
    const { actPromotion } = act
    const { startTime } = actPromotion
    // console.log('秒杀未开始', startTime * 1000 > new Date().getTime())
    if (startTime * 1000 > new Date().getTime()) {
      act.__hiddenAct = 1
      return
    }
    const { actPromotionGoodsDtoList } = actPromotion
    getActPrice(actPromotionGoodsDtoList, item)
  }
  function handlerActType6(act, item) {
    const { actPromotion } = act
    const { actPromotionGoodsDtoList } = actPromotion
    getActPrice(actPromotionGoodsDtoList, item)
  }
  function handlerActType4(act, item) {
    const { actPromotion } = act
    const { actPromotionGoodsDtoList } = actPromotion
    getActPrice(actPromotionGoodsDtoList, item)
  }
  function getActPrice(actGoodsList, item) {
    if (actGoodsList && actGoodsList.length) {
      actGoodsList.forEach((actGoods) => {
        if (actGoods.goodsId === item.skuId) {
          item.__actPrice = actGoods.actPrice
        }
      })
    }
  }
}
